import { Colors } from './Colors';

export const hoverCss = {
  '&:hover': {
    boxShadow: 'md',
    borderColor: 'neutral.outlinedHoverBorder',
    cursor: 'pointer'
  }
};

export const selectedCss = {
  border: `1px solid ${Colors.ocdGreen}`,
  borderRadius: '16px',
  boxShadow: `5px 10px 10px ${Colors.ocdGreen}`
};
